import React, { PureComponent } from 'react'
import styled from 'styled-components'

import { media } from 'gipsy-ui'
import { slack } from 'gipsy-api'
import { styles, translations, utils } from 'gipsy-misc'

import { Header, SectionContainer } from 'pages/settings/components/common'
import { Block } from 'features/settings'

const EXTENSION_ID = process.env.REACT_APP_CHROME_EXTENSION_ID
const EXTENSION_LINK = EXTENSION_ID && `https://chrome.google.com/webstore/detail/${EXTENSION_ID}`

class Apps extends PureComponent {
  state = {
    slackAuthUrl: ''
  }
  componentDidMount = () => {
    this.fetchSlackAuthUrl()
  }
  fetchSlackAuthUrl = async () => {
    const slackAuthUrl = await slack.getAuthURL()
    this.setState({ slackAuthUrl })
  }

  render() {
    const macAppDownloadUrl = `https://s3.amazonaws.com/desktop-apps.${process.env.REACT_APP_PROFILE}.com/Gipsybot.dmg`
    return (
      <AppSectionContainer>
        <Header title={translations.settings.section.apps.title} />
        <RowContainer>
          <Block
            appTitle={translations.settings.section.apps.section.slackApp.title}
            sourcePath={'/images/slack_icon.svg'}
            actionLink={this.state.slackAuthUrl}
            badgeTitle={translations.general.new}
            badgeColor={'#FFFFFF'}
            badgeBackground={styles.colors.backgroundPrimaryColor}
            appAction={translations.general.install}
            text={translations.settings.section.apps.section.slackApp.text}
          />
          <MiddleContainer />
          <Block
            appTitle={translations.settings.section.apps.section.chromeext.title}
            sourcePath={'/images/chrome.png'}
            appAction={translations.settings.section.apps.section.chromeext.action}
            actionLink={EXTENSION_LINK}
            text={translations.settings.section.apps.section.chromeext.text}
            hideMobile={true}
          />
        </RowContainer>
        <RowContainer>
          <Block
            appTitle={translations.settings.section.apps.section.macApp.title}
            sourcePath={'/images/dark_apple.svg'}
            appAction={translations.settings.section.apps.download}
            actionLink={macAppDownloadUrl}
            text={translations.settings.section.apps.section.macApp.text}
            hideMobile={true}
          />
          <MiddleContainer />
          <Block
            appTitle={translations.settings.section.apps.section.windowsApp.title}
            sourcePath={'/images/windows.svg'}
            badgeTitle={utils.string.capitalize(translations.general.soon)}
            badgeColor={'#FFFFFF'}
            badgeBackground={'linear-gradient(180deg, #B9B7C9 0%, #ADABBC 100%);'}
            appAction={translations.settings.section.apps.download}
            hideMobile={true}
          />
        </RowContainer>
        <RowContainer>
          <Block
            appTitle={translations.settings.section.apps.section.iOSApp.title}
            sourcePath={'/images/light_apple.svg'}
            actionLink={'https://apps.apple.com/us/app/gipsybot/id1458517773'}
            badgeTitle={translations.general.new}
            badgeColor={'#FFFFFF'}
            badgeBackground={styles.colors.backgroundPrimaryColor}
            appAction={translations.settings.section.apps.download}
          />
          <MiddleContainer />
          <Block
            appTitle={translations.settings.section.apps.section.androidApp.title}
            sourcePath={'/images/android_icon.png'}
            badgeTitle={utils.string.capitalize(translations.general.soon)}
            badgeColor={'#FFFFFF'}
            badgeBackground={'linear-gradient(180deg, #B9B7C9 0%, #ADABBC 100%);'}
            appAction={translations.settings.section.apps.download}
          />
        </RowContainer>
      </AppSectionContainer>
    )
  }
}

const AppSectionContainer = styled(SectionContainer)`
  ${media['phone-wide']`
  div:last-child{
    margin-bottom:0px;
  }
`}
`
const RowContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 20px;
  ${media['phone-wide']`
  flex-direction: column;
  margin-bottom:0px;
`}
`

const MiddleContainer = styled.div`
  width: 32px;
`

export default Apps



// WEBPACK FOOTER //
// ./src/pages/settings/components/apps/index.js